import axios from 'axios';

/**
 * The API answers 423 to every call from an employee whose lay-off notice is waiting for
 * their signature. Services use both fetch and axios, each with their own response handling,
 * so this watches both and tells the LayoffLockGate to re-check (it then shows the notice).
 */
export const LAYOFF_LOCK_EVENT = 'firestorm:layoff-locked';

const isLockResponse = (status, url) =>
  status === 423 && !String(url || '').includes('/api/layoffs/notice');

const announceLock = () => window.dispatchEvent(new Event(LAYOFF_LOCK_EVENT));

// Patching fetch and adding the axios interceptor must happen once (StrictMode, hot reload)
let installed = false;

export function installLayoffLockListener() {
  if (installed) {
    return;
  }
  installed = true;

  const originalFetch = window.fetch.bind(window);
  window.fetch = async (...args) => {
    const response = await originalFetch(...args);
    if (isLockResponse(response.status, response.url)) {
      announceLock();
    }
    return response;
  };

  axios.interceptors.response.use(
    (response) => response,
    (error) => {
      if (isLockResponse(error?.response?.status, error?.config?.url)) {
        announceLock();
      }
      return Promise.reject(error);
    },
  );
}
